
import { RootState } from '@redux/store';
import {AlertResponse, useGetAlertsQuery} from '@services/alertApi';
import {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import AlertBanner from '@pages/Home/components/Alert/AlertBanner';
import React from 'react';
import {useTranslation} from "react-i18next";
import {isLocalEnvironment, isTestEnvironment} from "@utils/locationHelper";
import {TFunction} from "i18next";

const alertBannerWarningKey = 'alert_banner_warning';
const alertBannerErrorKey = 'alert_banner_error';
const alertBannerInfoKey = 'alert_banner_info';

function getHardCodedAlerts(t: TFunction<"translation", undefined>) {

  const additionalAlerts: AlertResponse[] = [];
  
  const alertBannerWarningMessage = t(alertBannerWarningKey);
  const alertBannerErrorMessage = t(alertBannerErrorKey);
  const alertBannerInfoMessage = t(alertBannerInfoKey);

  if (alertBannerInfoMessage && alertBannerInfoMessage !== alertBannerInfoKey) {
    additionalAlerts.push({
      data: alertBannerInfoMessage,
      id: 13360000,
      level: 0,
      unclosable: false,
      name: 'generic-message'
    } as AlertResponse);  
  }

  if (alertBannerWarningMessage && alertBannerWarningMessage !== alertBannerWarningKey) {
    additionalAlerts.push({
      data: alertBannerWarningMessage,
      id: 13370000,
      level: 1,
      unclosable: false,
      name: 'generic-message'
    } as AlertResponse);  
  }

  if (alertBannerErrorMessage && alertBannerErrorMessage !== alertBannerErrorKey) {
    additionalAlerts.push({
      data: alertBannerErrorMessage,
      id: 13380000,
      level: 2,
      unclosable: false,
      name: 'generic-message'
    } as AlertResponse);  
  }

  if (isLocalEnvironment()) {
    additionalAlerts.push({
      data: "🧪 Local Environment 🧪",
      id: 42000000,
      level: 1,
      unclosable: true,
      name: 'generic-message'
    } as AlertResponse);
  }

  if (isTestEnvironment()) {
    additionalAlerts.push({
      data: "🦏 Test Environment 🦏",
      id: 6900000,
      level: 1,
      unclosable: true,
      name: 'generic-message'
    } as AlertResponse);
  }
  return additionalAlerts;
}


interface LayoutHeaderProps {
  onAlertHeightChange: (height: number) => void;
}

const LayoutHeader: React.FC<LayoutHeaderProps> = ({ onAlertHeightChange }) => {
  const [alertsData, setAlertsData] = useState<AlertResponse[]>([]);
  const [showAlertBanner, setShowAlertBanner] = useState(true);
  const {t} = useTranslation();
  const userState = useSelector((state: RootState) => state.user);
  const { data } = useGetAlertsQuery(userState?.user?.id, {
    skip: !userState?.user?.id,
  });

  useEffect(() => {
    const additionalAlerts = getHardCodedAlerts(t);

    if (userState?.user?.id && data && data.length > 0) {
      setAlertsData([...additionalAlerts, ...data]);
    } else { // remove alert on log out or if no alerts are returned from the API
      setAlertsData([...additionalAlerts]);
    }
  }, [userState?.user?.id, data, t]);

  return (
    <>
      <Header isAlert={alertsData?.length > 0 && showAlertBanner}/>
      {alertsData?.length > 0 && showAlertBanner && (
        <AlertBanner
          alertData={alertsData}
          onHeightChange={onAlertHeightChange}
          onClose={() => setShowAlertBanner(false)}
        />
      )}
    </>
  );
};

export default LayoutHeader;
